export class PatientDocumentsModel
{
id = 0 ;
patientcode = '' ;
doccode = '' ;
docname = '' ;
docdate = '2024-01-01' ;
doctype = '' ;
pathimage = '' ;
fileimage :File |null ;
pathimage_1 :any ;
fileBytes ='';
docnotes = '';
doctime = '2024-01-01';
documenttype = '';
userid = '' ;
modifieddate = '2024-01-01' ;
compcode = '' ;

}
